// @ vendor
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_FAILURE,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_FAILURE
} = require('../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        insuranceSummary: {
            base64string: '',
            base64: null,
            contentType: '',
        },
        insuranceSummaryRelated: {
            base64string: '',
            base64: null,
            contentType: '',
        },
        insuranceSummaryRnc: {
            base64string: '',
            base64: null,
            contentType: '',
        },
        isFetchingSummary: false,
        isFetchingZip: false,
        summaryError: false,
        downloadZipError: false,
        insuranceSummaryZip: null,
        insuranceSummaryRelatedZip: null,
        insuranceSummaryRncZip: null,
    });
};

const insuranceRequestLegalDocuments = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_REQUEST:
            return state.merge({
                isFetchingSummary: true,
                summaryError: false
            });

        case INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_SUCCESS:
            return state.merge({
                [action.data.wizard]: {
                    base64string: action.data.b64toBlobResponse.base64string,
                    base64: action.data.b64toBlobResponse.base64,
                    contentType: action.data.b64toBlobResponse.contentType,
                },
                isFetchingSummary: false,
                summaryError: false
            });

        case INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_FAILURE:
            return state.merge({
                isFetchingSummary: false,
                summaryError: true
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_ZIP_REQUEST:
            return state.merge({
                isFetchingZip: true
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_ZIP_SUCCESS:
            return state.merge({
                isFetchingZip: false,
                [action.data.zipWizardName]: action.data.zipData
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_ZIP_FAILURE:
            return state.merge({
                isFetchingZip: false,
                downloadZipError: true
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestLegalDocuments;
